import { selectHelper } from '../../common/helpers'
import { messages } from '../../common/constants'


export const selectQuotationForEdit = (state) => {
    const { quotation } = state.quotation.quotationList

    var quotationValues = {}

    if (!quotation) return quotationValues
    quotationValues = {
        code: quotation.code,
        customer: quotation.Customer.id,
        store: quotation.Store.id,
        expirationDate: quotation.expirationDate,
        totalPrice: quotation.totalPrice,
        discount: quotation.discount == 0 ? quotation.discount : quotation.discount * 100,
        totalPriceDiscounted: quotation.totalPriceDiscounted,
        products: quotation.products,
        services: quotation.services,
        offers: quotation.offers
    };
    return quotationValues
}



// WEBPACK FOOTER //
// ./src/store/quotation/selector.js